export { default } from './TouchFeedback';


//////////////////
// WEBPACK FOOTER
// ./~/rmc-feedback/es/index.js
// module id = 367
// module chunks = 124